import { Stack, styled, Typography } from '@mui/material';

interface StyledProps {
  isFreeAccount?: boolean;
}

export const StyledOuterContainer = styled(Stack)<StyledProps>(
  ({ theme, isFreeAccount }) => ({
    gap: theme.spacing(1),
    width: '100%',
    opacity: isFreeAccount ? 0.5 : 1,
  })
);

export const StyledContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3),
  gap: theme.spacing(2),
  background: theme.palette.grey[800],
}));

export const StyledTextContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-start',
  gap: theme.spacing(0.5),
}));

export const StyledTitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[50],
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: theme.spacing(3),
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[50],
  fontSize: 12,
  fontStyle: 'normal',
}));
